export default {
  'setting.pagestyle': 'Page style setting',
  'setting.pagestyle.dark': 'Dark style',
  'setting.pagestyle.light': 'Light style',
  'setting.content-width': 'Content Width',
  'setting.content-width.fixed': 'Fixed',
  'setting.content-width.fluid': 'Fluid',
  'setting.themecolor': 'Theme Color',
  'setting.themecolor.dust': 'Dust Red',
  'setting.themecolor.volcano': 'Volcano',
  'setting.themecolor.sunset': 'Sunset Orange',
  'setting.themecolor.cyan': 'Cyan',
  'setting.themecolor.green': 'Polar Green',
  'setting.themecolor.daybreak': 'Daybreak Blue (default)',
  'setting.themecolor.geekblue': 'Geek Glue',
  'setting.themecolor.purple': 'Golden Purple',
  'setting.navigationmode': 'Navigation Mode',
  'setting.sidemenu': 'Side Menu Layout',
  'setting.topmenu': 'Top Menu Layout',
  'setting.fixedheader': 'Fixed Header',
  'setting.fixedsidebar': 'Fixed Sidebar',
  'setting.fixedsidebar.hint': 'Works on Side Menu Layout',
  'setting.hideheader': 'Hidden Header when scrolling',
  'setting.hideheader.hint': 'Works when Hidden Header is enabled',
  'setting.othersettings': 'Other Settings',
  'setting.weakmode': 'Weak Mode',
  'setting.copy': 'Copy Setting',
  'setting.copyinfo': 'copy success，please replace defaultSettings in src/models/setting.js',
  'setting.production.hint':
    'Setting panel shows in development environment only, please manually modify',
};
